import React from "react";
import { motion } from "framer-motion";

const PAINS = [
  {
    n: "01",
    line: "Sabes lo que deberías hacer…",
    after: "y aun así vuelves a hacer lo mismo.",
  },
  {
    n: "02",
    line: "Prometes que esta vez será diferente…",
    after: "y meses después te encuentras en el mismo lugar.",
  },
  {
    n: "03",
    line: "Cambia el escenario, la relación, el trabajo…",
    after: "pero la sensación termina siendo parecida.",
  },
  {
    n: "04",
    line: "Quieres avanzar…",
    after: "y cuando estás cerca, algo te sabotea.",
  },
];

export default function AgitateSection() {
  return (
    <section
      id="quiza"
      className="section-light relative py-24 md:py-36 overflow-hidden"
      data-testid="agitate-section"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <p className="overline mb-6">◇ Quizá no eres así</p>
          <h2 className="font-serif font-normal text-4xl sm:text-5xl lg:text-6xl text-[#0B0E13] leading-[1.05] tracking-[-0.01em]">
            Quizá no eres así.
            <br />
            <span className="italic text-[#6E7580]">Es un personaje.</span>
          </h2>
          <div className="gold-divider mt-8" />
          <p className="mt-8 text-lg sm:text-xl text-[#2A303A] leading-[1.6] max-w-2xl font-light font-sans">
            Puedes entender lo que te ocurre y aun así seguir repitiéndolo. No porque no quieras
            cambiar, sino porque comprender un patrón no es lo mismo que haberlo transformado.
          </p>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8">
          {PAINS.map((p, i) => (
            <motion.div
              key={p.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="flex items-start gap-6 pb-8 border-b border-[#0B0E13]/10"
              data-testid={`pain-${i}`}
            >
              <span className="font-serif text-[#C7AA78] text-base shrink-0 pt-1 italic">
                {p.n}
              </span>
              <div>
                <p className="font-serif italic text-[#0B0E13] text-xl md:text-2xl leading-snug tracking-[-0.005em]">
                  {p.line}
                </p>
                <p className="mt-2 text-[#2A303A] text-lg leading-relaxed font-light font-sans">
                  {p.after}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="mt-20 max-w-3xl"
        >
          <p className="font-serif text-2xl sm:text-3xl md:text-4xl text-[#0B0E13] font-normal leading-[1.35] tracking-[-0.005em]">
            Cuando cambia el escenario pero se repite la historia,{" "}
            <span className="italic text-[#8E7A55]">
              quizá ha llegado el momento de mirar el personaje.
            </span>
          </p>
        </motion.div>
      </div>
    </section>
  );
}
